import * as types from './mutation-types'
import { services } from './api'
import {router} from '../router'
export const fetchProduct = ({ commit }) => {
  // API request
  return services.products.getAll()
  .then((response) => {
    console.log(response)
    commit(types.FETCH_PRODUCT, response.data)
  })
  .catch((error) => {
    console.error(error)
  })
}

export const fetchTask = ({ commit }) => {
  // API request
  return services.tasks.getAll()
  .then((response) => {
    commit(types.FETCH_TASK, response.data)
  })
  .catch((error) => {
    console.error(error)
  })
}

export const processLogin = ({ commit } , { username , password } ) => {
  return services.user.login( { contactNumber: username, password: password } )
  .then((response) => {
    // console.log('VVVVVVVV++++++LOGIN---->>>>>')
    // console.log(response)
    commit(types.LOGIN, response.data)
    router.push( '/')
  })
  .catch((error) => {
    console.log(error)
    console.log('CHECK->AFNAN')
    // console.log(error)
    commit(types.ERROR, error.response.data.errors)
  })
}

export const processLogout = ({ commit }) => {
    commit(types.LOGOUT)
    router.push( '/login')
}

export const getLoginStatus = ({ commit }) => {
  commit(types.LOGIN_STATUS)
}

export const getLanguage = ({ commit }) => {
  commit(types.GET_LAN)
}
export const setLanguage = ({ commit } , language) => {
  commit(types.SET_LAN ,language )
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js